module.exports = __webpack_public_path__ + "static/media/white-iphone.e1d97797.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/white-iphone.png
// module id = 436
// module chunks = 0